export default __webpack_public_path__ + "static/media/GLogo.d90e9241.svg";